import React, { useState } from "react";

const BookingFeedback = ({ isVisible, onClose, onFeedback }) => {
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);

  const handleFeedback = async (isPositive) => {
    try {
      await onFeedback(isPositive);
      setFeedbackSubmitted(true);
      
      // Auto close after 2 seconds
      setTimeout(() => {
        setFeedbackSubmitted(false);
        onClose();
      }, 2000);
    } catch (error) {
      console.error("Error submitting feedback:", error);
      // Still close the modal even if feedback fails
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 transform transition-all duration-300 scale-100">
        {!feedbackSubmitted ? (
          <>
            {/* Feedback Request */}
            <div className="text-center mb-6">
              <div className="w-16 h-16 mx-auto mb-4 bg-blue-100 rounded-full flex items-center justify-center">
                <svg 
                  className="w-8 h-8 text-blue-600" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth="2" 
                    d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Quick Feedback
              </h3>
              <p className="text-gray-600">
                Was the booking process helpful and easy to use?
              </p>
            </div>

            {/* Feedback Buttons */}
            <div className="flex justify-center space-x-4 mb-6">
              <button
                onClick={() => handleFeedback(true)}
                className="flex flex-col items-center p-4 bg-green-50 hover:bg-green-100 border-2 border-green-200 hover:border-green-300 rounded-xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-green-200"
              >
                <svg 
                  className="w-8 h-8 text-green-600 mb-2" 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" 
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-sm font-medium text-green-700">
                  👍 Yes, helpful!
                </span>
              </button>

              <button
                onClick={() => handleFeedback(false)}
                className="flex flex-col items-center p-4 bg-red-50 hover:bg-red-100 border-2 border-red-200 hover:border-red-300 rounded-xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-red-200"
              >
                <svg 
                  className="w-8 h-8 text-red-600 mb-2" 
                  fill="currentColor" 
                  viewBox="0 0 20 20"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" 
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-sm font-medium text-red-700">
                  👎 Needs improvement
                </span>
              </button>
            </div>

            {/* Skip Button */}
            <div className="text-center">
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 text-sm font-medium transition-colors duration-200"
              >
                Skip feedback
              </button>
            </div>
          </>
        ) : (
          <>
            {/* Thank You Message */}
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
                <svg 
                  className="w-8 h-8 text-green-600" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth="2" 
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Thank You!
              </h3>
              <p className="text-gray-600">
                Your feedback helps us improve our service.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BookingFeedback;